<content-panel class="container">
  <panel-header heading="{{ this.corpAdminConstants.taskTableTitle }}">
    <!-- create button -->
    <button class="create-button" mat-icon-button (click)="addNewTask()">
      <mat-icon>add</mat-icon>
    </button>
  </panel-header>

  <panel-body>
    <div>
      <section>
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
          <!-- Item Name -->
          <ng-container matColumnDef="itemName">
            <th mat-header-cell *matHeaderCellDef><b> Item Name </b></th>
            <td
              mat-cell
              *matCellDef="let element"
              class="name-column"
              [matTooltip]="element.InspectionTask.Name"
            >
              {{ element.InspectionTask.Name }}
            </td>
          </ng-container>
          <!-- Category -->
          <ng-container matColumnDef="category">
            <th mat-header-cell *matHeaderCellDef class="column-style">
              <b> Category </b>
            </th>
            <td mat-cell *matCellDef="let element" class="column-style">
              @for (cat of element.TaskClassificationAssignments; track cat) {
                <mat-chip class="category-chip">{{
                  cat.ClassificationName
                }}</mat-chip>
              }
            </td>
          </ng-container>
          <!-- Creation Date -->
          <ng-container matColumnDef="creationDate">
            <th mat-header-cell *matHeaderCellDef class="column-style">
              <b> Creation Date </b>
            </th>
            <td mat-cell *matCellDef="let element" class="column-style">
              {{ element.InspectionTask.CreatedOn | date }}
            </td>
          </ng-container>
          <!-- Required -->
          <ng-container matColumnDef="required">
            <th mat-header-cell *matHeaderCellDef class="column-style">
              <b> Required? </b>
            </th>
            <td mat-cell *matCellDef="let element" class="column-style">
              @if (element.InspectionTask.IsRequired) {
                <span class="chip-styling true-chip">
                  {{ corpAdminConstants.trueChip }}
                </span>
              } @else {
                <span class="chip-styling false-chip">
                  {{ corpAdminConstants.falseChip }}
                </span>
              }
            </td>
          </ng-container>
          <!-- Action -->
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef class="column-style"></th>
            <td mat-cell *matCellDef="let element" class="column-style">
              <button
                class="edit-button"
                mat-icon-button
                (click)="editTask(element)"
              >
                <mat-icon>edit</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr class="mat-row empty-table-row" *matNoDataRow>
            <td class="empty-table" [attr.colspan]="tableColumns.length">
              <div class="empty-text">
                {{ this.corpAdminConstants.taskTableEmpty }}
              </div>
            </td>
          </tr>

          <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
        </table>
      </section>
    </div>
  </panel-body>
</content-panel>
